<app-schedule-layout *ngIf="schedule && tags && locations" [ctx]="ctx"></app-schedule-layout>
